// 横書き
export function SetupArrow() {
  // すべてのarrow-pathを取得
  const paths = document.querySelectorAll(".js-svg-path");

  paths.forEach((path) => {
    // パスの実際の長さを計算
    const pathLength = path.getTotalLength();

    // CSS変数として設定
    path.style.setProperty("--path-length", pathLength);
  });
}
